import React, { SetStateAction } from "react";
import { Col, Form, Radio, Space } from "antd";
import { SaveOfferType } from "../../../../../types/model/saveOffer";

interface SaveOfferTypeSelectProps {
  setSelectedSaveOfferType: React.Dispatch<SetStateAction<SaveOfferType>>;
}

export function SaveOfferTypeSelect({ setSelectedSaveOfferType }: SaveOfferTypeSelectProps) {
  return (
    <Col span={24}>
      <Form.Item
        label="Save offer type"
        name="saveOfferType"
        initialValue={Object.values(SaveOfferType)[0]}
        rules={[{ required: true }]}
      >
        <Radio.Group onChange={(e) => setSelectedSaveOfferType(e.target.value)}>
          <Space size={12}>
            {Object.values(SaveOfferType).map((type) => (
              <Radio key={type} value={type}>
                {type}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      </Form.Item>
    </Col>
  );
}
